import { all, call, fork, put, takeLatest } from 'redux-saga/effects';

import { Creators as Actions, Types } from 'ducks/PrazoEntrega';
import { Creators as ActionsGeral } from 'ducks/Geral';
import api from '../api/api';
import notify from 'utils/modern_notify';

let prazoEntMens = '';
const buscListaEndPrazoEntReq = async (filtros) =>
	api.post(`/api/pesquisa/buscar`, filtros).then((dados) => dados).catch((error) => error);

const buscMuniIbgeReq = async (cod) =>
	api
		.get(`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${cod}/municipios`)
		.then((dados) => dados)
		.catch((error) => error);

const buscMuniBackReq = async (dados) =>
	api.post('api/destinatarios/busca/estado/prazo', dados).then((dados) => dados).catch((error) => error);

const atualizaPrazoMuniReq = async (dados) =>
	api.put(`/api/destinatarios/prazoentrega`, dados).then((dados) => dados).catch((error) => error);

function* atualizaPrazoMuni({ payload }) {
	const { listaComPrazos, novaLista, novaListaBack } = payload;
	let mensagem = '';
	try {
		const response = yield call(atualizaPrazoMuniReq, listaComPrazos);
		if (response.ok) {
			notify('Prazos atualizados com sucesso !',2)
			yield put(Actions.atualizaPrazoMuniSucesso(novaLista));
			yield put(Actions.atualizarListaBack({ novaListaBack }));
			yield put(Actions.setLoadPrazoEntre(false));
			yield put(Actions.setListaPrazoAlterado([]));
		} else {
			if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
				switch (response.data.error) {
					default:
						mensagem = `Ocorreu um erro requição de endereços: ${response.data.error}`;
						break;
				}
			} else {
				mensagem = 'Ocorreu um erro ao fazer a requição de endereços';
			}
			yield put(Actions.setLoadPrazoEntre(false));
			// yield put(ActionsGeral.setMensagem({ mensagem: 'Erro ao atualizar prazos.', mostrar: true }));
			notify('Erro ao atualizar prazos.')
		}
	} catch (error) {
		yield put(Actions.setLoadPrazoEntre(false));
		notify(`Erro ao atualizar prazos: ${error}`)
	}
}

function* buscListaEndPrazoEnt({ payload }) {
	const { filtros } = payload;
	prazoEntMens = '';
	let prazoEntDados = [];
	try {
		const response = yield call(buscListaEndPrazoEntReq, filtros);
		if (response.ok) {
			prazoEntDados = response.data.valor;
			yield put(Actions.buscListaEndPrazoEntSuces(prazoEntDados));
			yield put(Actions.setLoadPrazoEntre(false));
		} else {
			if (Object.prototype.hasOwnProperty.call(response.data, 'error')) {
				switch (response.data.error) {
					default:
						prazoEntMens = `Ocorreu um erro requição de endereços: ${response.data.error}`;
						break;
				}
			} else {
				prazoEntMens = 'Ocorreu um erro ao fazer a requição de endereços';
			}
			notify(prazoEntMens)
			yield put(Actions.setLoadPrazoEntre(false));
		}
	} catch (error) {
		notify('Erro ao buscar endereços.')
		yield put(Actions.setLoadPrazoEntre(false));
	}
}

function* buscaMunicipios({ payload }) {
	const { cod, cnpjEmpresa, cnpjRemetente, UF } = payload;
	let listaIbge = [];
	let listaBack = {};
	let mensagem = '';
	let dados = {
		uf: UF,
		cnpjEmpresa: Array.isArray(cnpjEmpresa) ? cnpjEmpresa : [ cnpjEmpresa ],
		cnpj_distribuidora: cnpjRemetente
	};

	if (cod == undefined || cod == '' || UF == '' || cnpjRemetente == undefined) {
		notify('Por favor, seleciona a distribuidora e o estado.',1)
		yield put(Actions.setLoadPrazoEntre(false));
	} else {
		try {
			const [ responseIbge, responseBack ] = yield all([
				call(buscMuniIbgeReq, cod),
				call(buscMuniBackReq, dados)
			]);
			if (responseIbge.ok && responseBack.ok) {
				listaIbge = responseIbge.data;
				listaBack = responseBack.data;
				yield put(Actions.buscaMunicipiosSucesso({ listaIbge, listaBack }));
			} else {
				if (
					Object.prototype.hasOwnProperty.call(responseIbge.data, 'error') ||
					Object.prototype.hasOwnProperty.call(responseBack.data, 'error')
				) {
					mensagem = `Ocorreu um erro requição de endereços: ${responseBack.data.error}`;
				} else {
					mensagem = 'Ocorreu um erro ao fazer a requição de endereços';
				}
				notify(mensagem)
				yield put(Actions.setLoadPrazoEntre(false));
			}
		} catch (error) {
			notify('Erro ao buscar endereços.')
			yield put(Actions.setLoadPrazoEntre(false));
		}
	}
}

export function* atualizaPrazoMuniAcao() {
	yield takeLatest(Types.ATUALIZA_PRAZO_MUNI, atualizaPrazoMuni);
}

export function* buscListaEndPrazoEntAcao() {
	yield takeLatest(Types.BUSC_LISTA_END_PRAZO_ENT, buscListaEndPrazoEnt);
}

export function* buscaMunicipiosAcao() {
	yield takeLatest(Types.BUSCA_MUNICIPIOS, buscaMunicipios);
}
export default function* rootSaga() {
	yield all([ fork(buscListaEndPrazoEntAcao), fork(buscaMunicipiosAcao), fork(atualizaPrazoMuniAcao) ]);
}
